document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".js-featured-product-banner");
    if(!section) return;

    const addToCartButton = section.querySelector(".js-featured-product-banner-atc");
    const subscriptionButton = section.querySelector(".js-featured-product-banner-subscription");
    if(!addToCartButton && !subscriptionButton) return;

    addToCartButton?.addEventListener("click", function(e) {
        console.log(e);
        addToCart(e.target.dataset.variantId);
    });

    subscriptionButton?.addEventListener("click", function(e) {
        addToCartSubs(e.target.dataset.variantId, e.target.dataset.variantSellingPlanId);
    });

    function addToCart(variantId) {
        let item = {
            id: variantId,
            quantity: 1
        }
        VueMinicart.config.globalProperties.$store.dispatch('addItem', item);
        return item;
    }

    function addToCartSubs(variantId, sellingPlanId) {
        let item = {
            id: variantId,
            selling_plan: sellingPlanId,
            quantity: 1
        }
        VueMinicart.config.globalProperties.$store.dispatch('addItem', item);
        return item;
    }
});